// extracted by mini-css-extract-plugin
export default {"cta":"wG-z","disabled":"xG-z"};